import getDistance from 'geolib/es/getDistance'
import { toHiragana, toKatakana } from './utils'
import api from '../../api'
import _ from 'lodash'
import Constants from '../../constants'

const getDefaultState = () => {
  return {
    // TODO: 緯度経度の持ち方として、latitudeとlongitudeとに統一した方がよさそう
    center: {
      lat: Constants.DEFAULT_STATION_LOCATION.latitude,
      lng: Constants.DEFAULT_STATION_LOCATION.longitude
    },
    from: {},
    durations: [],
    selectedPlace: {},
    showPlaceFull: false,
    googlePlaceMarker: {},
    spalMarker: {},
    showDocomoMobaku: false
  }
}

const state = getDefaultState()

const getters = {
  getCenter: (state) => state.center,
  getFrom: (state) => state.from,
  getDurations: (state) => state.durations.sort((a, b) => a.index - b.index),
  search: (state, _getters, _rootState, rootGetters) => (word) => {
    const places = _.cloneDeep(rootGetters['places/getPlaces'])

    return places
      .filter(place => (!place.genreIds.includes('stay') && !place.genreIds.includes('airport')))
      .filter(place => isMatch(place, word))
      .map(place => {
        return Object.assign(place, { distance: getDistance(place.location, state.center) })
      })
      .sort((a, b) => {
        return a.distance - b.distance
      })
  },
  getSelectedPlace: (state) => state.selectedPlace,
  getSelectedPlaceDuration: (state) => state.selectedPlaceDuration,
  getShowPlaceFull: (state) => state.showPlaceFull,
  getGooglePlaceMarker: (state) => state.googlePlaceMarker,
  getSpalMarker: (state) => state.spalMarker,
  getShowDocomoMobaku: (state) => state.showDocomoMobaku,
  getRecommendedPlaces: (state, _getters, _rootState, rootGetters) => {
    const places = _.cloneDeep(rootGetters['places/getPlaces'])
    const fromLocation = assignFromLocation(state.route, state.center)

    return places
      .filter(place => {
        return place.genreIds.includes('recommended-spots')
      })
      .map(place => {
        return Object.assign(place, { distance: getDistance(place.location, fromLocation) })
      })
      .sort((a, b) => {
        return a.distance - b.distance
      })
      .slice(0, 5)
  },
  getFavoritedPlaces: (state, _getters, _rootState, rootGetters) => {
    const places = _.cloneDeep(rootGetters['places/getPlaces'])
    const favorites = rootGetters['favorites/getFavorites']
    const fromLocation = assignFromLocation(state.route, state.center)

    return places
      .filter(place => {
        return favorites.includes(place.id)
      })
      .map(place => {
        return Object.assign(place, { distance: getDistance(place.location, fromLocation) })
      })
      .sort((a, b) => {
        return a.distance - b.distance
      })
      .slice(0, 5)
  }
}

const actions = {
  updateCenter ({ commit }, params) {
    commit('setCenter', params)
  },
  updateSelectedPlace ({ commit }, place) {
    commit('setSelectedPlace', place)
  },
  updateFrom ({ commit }, params) {
    commit('setFrom', params)
  },
  recommendSearchCourse({ state, commit, getters }) {
    const places = getters['getRecommendedPlaces']
    const favorited = getters['getFavoritedPlaces']
    const fromLocation = assignFromLocation(state.from.route, state.center)
    const durations = []

    // NOTE: ajaxで返ってきた順になってしまうので、距離順を保つためにindex情報を付加しておく
    places.concat(favorited)
      .forEach((place, index) => {
        const toLocation = place.location

        api.recommendSearchCourse({ fromLocation, toLocation })
          .then((duration) => {
            durations.push({
              index: index + 1,
              place: place,
              amount: duration
            })
          })
      })

    commit('setDurations', durations)
  },
  openPlace({ commit, dispatch }, { place, full }) {
    if (!_.isEmpty(place) && full) {
      const center = {
        lat: place.location.latitude,
        lng: place.location.longitude,
      }
      dispatch('updateCenter', center)
    }
    commit('setSelectedPlace', place)
    commit('setShowPlaceFull', full)
  },
  updateGooglePlaceMarker({ commit }, place) {
    commit('setGooglePlaceMarker', place)
  },
  updateSpalMarker({ commit }, place) {
    commit('setSpalMarker', place)
  },
  setShowDocomoMobaku({ commit }, isShow) {
    commit('setShowDocomoMobaku', isShow)
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setCenter (state, params) {
    state.center = params
  },
  setFrom (state, params) {
    state.from = params
  },
  setShowPlaceFull (state, full) {
    state.showPlaceFull = full
  },
  setSelectedPlace (state, place) {
    state.selectedPlace = place
  },
  setDurations (state, durations) {
    state.durations = durations
  },
  resetDurations (state) {
    state.durations = []
  },
  setGooglePlaceMarker(state, place) {
    state.googlePlaceMarker = place
  },
  setSpalMarker(state, place) {
    state.spalMarker = place
  },
  setShowDocomoMobaku(state, isShow) {
    state.showDocomoMobaku = isShow
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

/**
 * Private functions
 */

function isMatch(place, word) {
  const hiragana = toHiragana(word)
  const katakana = toKatakana(word)

  return isPlaceMatch(place, hiragana, katakana)
    || isGenreWordsMatch(place, hiragana, katakana)
}

function isPlaceMatch(place, hiragana, katakana) {
  const attributes = ['detail', 'name', 'name_yomi']
  const match = attributes.filter(a => {
    return place[a] && (place[a].indexOf(hiragana) > -1 || place[a].indexOf(katakana) > -1)
  })

  return match.length > 0
}

function isGenreWordsMatch(place, hiragana, katakana) {
  const genreWords = place.genreWords.join(',')

  return genreWords.indexOf(hiragana) > -1 ||
    genreWords.indexOf(katakana) > -1
}

function assignFromLocation(route, center) {
  let location = {
    latitude: center.lat,
    longitude: center.lng
  }

  if (route) {
    const point = route.points[0]
    location = point.location
  }

  return location
}
